/**
 * An option to indicate what type of test was carried out for the Field Density Test
 */
export enum FdMeasurementApplication {
  ComparativeTests = 'GroundInvestigationComparativeTests',
  AbsoluteTests = 'GroundInvestigationAbsoluteTests',
  ComplianceTest = 'ComplianceTest',
}

/**
 * An option to indicate the orientation of the additional reading
 */
export enum RelativeOrientation {
  StraightAngle = 'StraightAngle',
  HorizontallyAdjacent = 'HorizontallyAdjacent',
  VerticallyAdjacent = 'VerticallyAdjacent',
}

/**
 * An option to indicate what mode was used for the Nuclear Density Gauge
 */
export enum NuclearDensityGaugeMode {
  DirectTransmission = 'DirectTransmission',
  Backscatter = 'Backscatter',
}

/**
 * An option to indicate how the gauge moisture content was determined
 */
export enum GaugeMoistureContentDeterminedBy {
  Directly = 'DirectlyMeasured',
  FromMoistureDensity = 'FromMoistureDensity',
}
